module.exports = __webpack_public_path__ + "img/btnStatus10.a856bcb5.png";